import React, { useState } from "react";
import FormSectionLayout from "components/layouts/FormSectionLayout";
import { Row, Col } from "reactstrap";
import ButtonComponent from "components/common/Button/ButtonComponent";
import { Can } from "config/Can";
import TextField from "components/common/TextField/TextField";
import { IPlanOutputSectionProps } from "./PlanOutputSection.interface";

const PlanOutputSection: React.FunctionComponent<IPlanOutputSectionProps> = (
  props
) => {
  const [jobId, setJobId] = useState(props.jobId || "");

  const handleSubmit = () => {
    if (jobId) {
      props.downloadPlanOutputCsv(jobId);
      setJobId("");
    }
  };

  return (
    <div className="plan-output-container">
      <FormSectionLayout subTitleText="Plan Output">
        <section className="form-group search-container">
          <TextField
            id="jobId"
            name="jobId"
            label="SELECT JOB ID"
            placeholder="Enter Job ID"
            value={jobId}
            handleChange={(e) => {
              setJobId(e.target.value);
            }}
          />
          <section className="form-row-separator">
            <Can I="create" a="plan">
              <Row>
                <Col lg="6">
                  <ButtonComponent
                    buttonClass="large-button btn-primary"
                    buttonText="Download Output"
                    onClickHandler={handleSubmit}
                    isDisable={props.isLoading || !jobId}
                  />
                </Col>
              </Row>
            </Can>
          </section>
        </section>
      </FormSectionLayout>
    </div>
  );
};

PlanOutputSection.defaultProps = {};

export default PlanOutputSection;
